// AsistenteFab.jsx
// Burbuja flotante abajo a la derecha que abre el chat de Wayo, igual que el FAB
// que la app tiene en Inicio. Es el sitio donde el visitante espera encontrar un
// chat, así que no roba espacio a ninguna sección.
import React, { useEffect, useRef, useState } from "react";
import ChatWayo from "./ChatWayo";
import "./AsistenteFab.css";
import { trackAsistenteAbierto } from "../analytics/googleAnalytics";

// El teaser se enseña UNA sola vez por visita: insistir con "¿Qué ceno hoy?"
// cada vez que se cierra el chat o se cambia de página molesta más que ayuda.
const TEASER_KEY = "wayo_teaser_visto";

const teaserYaVisto = () => {
  try {
    return sessionStorage.getItem(TEASER_KEY) === "1";
  } catch {
    return false;
  }
};

const marcarTeaserVisto = () => {
  try {
    sessionStorage.setItem(TEASER_KEY, "1");
  } catch {
    /* modo incógnito o storage bloqueado: no pasa nada, se muestra otra vez */
  }
};

export default function AsistenteFab() {
  const [abierto, setAbierto] = useState(false);
  const [teaserVisible, setTeaserVisible] = useState(false);
  const botonRef = useRef(null);

  // Aparece a los 4s, una única vez. Si ya se enseñó (o el visitante abrió el
  // chat) no vuelve a salir: queda solo el círculo de Wayo.
  useEffect(() => {
    if (abierto || teaserYaVisto()) return undefined;
    const t = setTimeout(() => {
      setTeaserVisible(true);
      marcarTeaserVisto();
    }, 4000);
    return () => clearTimeout(t);
  }, [abierto]);

  // Y se retira sola a los 8s, sin tener que cerrarla a mano.
  useEffect(() => {
    if (!teaserVisible) return undefined;
    const t = setTimeout(() => setTeaserVisible(false), 8000);
    return () => clearTimeout(t);
  }, [teaserVisible]);

  // Escape cierra, y el foco vuelve al botón: si no, se queda perdido en el body.
  useEffect(() => {
    if (!abierto) return undefined;
    const alPulsar = (e) => {
      if (e.key === "Escape") {
        setAbierto(false);
        if (botonRef.current) botonRef.current.focus();
      }
    };
    window.addEventListener("keydown", alPulsar);
    return () => window.removeEventListener("keydown", alPulsar);
  }, [abierto]);

  // Separo botón y teaser para saber cuál de los dos abre el chat: si el teaser
  // no aporta aperturas, sobra y deja de molestar a los 4 segundos.
  const abrir = (origen) => {
    trackAsistenteAbierto(origen);
    setTeaserVisible(false);
    setAbierto(true);
  };

  return (
    <div className="fabw">
      {abierto && (
        <div className="fabw-panel" role="dialog" aria-label="Chat con Wayo">
          <ChatWayo alto={null} origen="fab" onCerrar={() => setAbierto(false)} />
        </div>
      )}

      {!abierto && teaserVisible && (
        <button type="button" className="fabw-teaser" onClick={() => abrir("teaser")}>
          <strong>¿Qué ceno hoy?</strong>
          <span>Pregúntaselo a Wayo. Sabe lo que llevas comido.</span>
        </button>
      )}

      {!abierto && (
        <button
          type="button"
          ref={botonRef}
          className="fabw-boton"
          onClick={() => abrir("boton")}
          aria-label="Abrir el chat con Wayo"
        >
          <img src="/assets/img/coach-wayo.webp" alt="" width="40" height="40" />
          <span className="fabw-pulso" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
